import ForgotPassword from "../Component/ForgotPassword";
import { connect } from 'react-redux';
import { forGotPWD } from '../../../../Action';


const mapStateToProps = (state) => {
  let { ForgotPwd } = state;
  return {
    ForgotPwd
  }
}
const actionCreators = {
  forGotPWD
}
export default (connect(mapStateToProps, actionCreators)(ForgotPassword));